import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvService } from 'src/app/services/env.service';

@Injectable({
  providedIn: 'root',
})
export class StikeUserService {
  readonly Api_url = this.env.URL_API_V1;
  constructor(private http: HttpClient, private env: EnvService) {}
  getStrikeCountByAlertForUser(id, createdAt: any) {
    return this.http.get<any[]>(
      `${this.Api_url}/strike_user/getStrikeCountByAlertForUser/${id}`,
      createdAt
        ? {
            params: { beging: createdAt.beging, end: createdAt.end },
          }
        : {}
    );
  }
}
